import map from "lodash/map";

// @ts-expect-error legacy
import Formatter from "@/legacy/Formatter";
import {AuditDetailsTable} from "@/pages/pagespeed/report/body/AuditDetailsTable.tsx";
import {RequestChain} from "@/pages/pagespeed/report/body/RequestChain.tsx";
import {PSTreemapNode, TreemapNode} from "@/pages/pagespeed/report/body/TreemapNode.tsx";

export const AuditDetails = ({audit}: {audit: unknown}) => {
  let detailsBlock = null;
  // @ts-expect-error unknown type
  const details = audit?.details;
  if (details) {
    if (details.type === "opportunity" && details.items) {
      // @ts-expect-error unknown type
      const hdrs = details.headings.map((h) => ({
        ...h,
        type: h.valueType,
        text: h.label,
      }));
      // @ts-expect-error unknown type
      const subhdrs = details.headings.map((h) => {
        if (h.subItemsHeading) {
          return {
            key: h.subItemsHeading.key,
            type: h.subItemsHeading.valueType || h.valueType,
          };
        }
        return null;
      });
      detailsBlock = <AuditDetailsTable headings={hdrs} items={details.items} subheadings={subhdrs} />;
    } else if (details.type === "table" && details.items) {
      // @ts-expect-error unknown type
      const hdrs = details.headings.map((h) => ({
        ...h,
        type: h.valueType || h.itemType,
        text: h.label || h.key,
      }));
      // @ts-expect-error unknown type
      const subhdrs = details.headings.map((h) => {
        if (h.subItemsHeading) {
          return {
            key: h.subItemsHeading.key,
            type: h.subItemsHeading.valueType || h.subItemsHeading.itemType || h.type,
          };
        }
        return null;
      });
      detailsBlock = <AuditDetailsTable headings={hdrs} items={details.items} subheadings={subhdrs} />;
    } else if (details.type === "debugdata") {
      /**
       * A details type that is not rendered in the final report; usually used
       * for including debug information in the LHR. Can contain anything.
       */
      return null;
    } else if (details.type === "criticalrequestchain") {
      const l = details.longestChain;
      detailsBlock = (
        <>
          <div>
            <strong>
              Longest chain: Duration {Formatter.autoDuration(l.duration / 1000)}, length: {l.length}, size:{" "}
              {Formatter.humanBytes(l.transferSize)}
            </strong>
          </div>
          <ul>
            {map(details.chains, (c: RequestChain, k: number) => (
              <RequestChain chain={c} key={k.toString()} />
            ))}
          </ul>
        </>
      );
    } else if (details.type == "treemap-data") {
      return (
        <ul>
          {details.nodes.map((x: PSTreemapNode) => (
            <TreemapNode node={x} />
          ))}
        </ul>
      );
    } else if (details.type === "filmstrip") {
      const frames = details.items.map((i: {timing: string; data: string}) => {
        return (
          <div key={i.timing} className="filmstrip-frame">
            <img alt="filmstrip frame" src={i.data} />
            <div className="filmstrip-frame-label">{Formatter.formatMs(i.timing)}</div>
          </div>
        );
      });
      detailsBlock = <div className="filmstrip">{frames}</div>;
    } else if (details.type === "screenshot") {
      detailsBlock = (
        <div className="screenshot">
          <img alt="screenshot" src={details.data} />
        </div>
      );
    } else if (details.type === "list") {
      const items = details.items.map((i: {text: string}) => {
        return <li key={i.text}>{i.text}</li>;
      });
      detailsBlock = <ul>{items}</ul>;
    } else if (details.type === "text") {
      detailsBlock = <div className="text">{details.text}</div>;
    } else {
      return (
        <div>
          Unsupported Details Type: {details.type}
          <br />
        </div>
      );
    }
  }
  return detailsBlock;
};
